import { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { InnovaSignal } from "@/client-admin/types.gen";
import { DataTableColumnHeader } from "../UserTable/data-table-column-header";

export const columns: ColumnDef<InnovaSignal>[] = [
  {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && "indeterminate")}
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
        className="translate-y-[2px]"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
        className="translate-y-[2px]"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "DeliveryDate",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Delivery Date" />,
    cell: ({ row }) => <div>{row.getValue("DeliveryDate")}</div>,
  },
  {
    accessorKey: "Start",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Start" />,
    cell: ({ row }) => <div>{(row.getValue("Start") as string).slice(0, 5)}</div>,
  },
  {
    accessorKey: "End",
    header: ({ column }) => <DataTableColumnHeader column={column} title="End" />,
    cell: ({ row }) => <div>{(row.getValue("End") as string).slice(0, 5)}</div>,
  },
  {
    accessorKey: "Side",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Side" />,
    cell: ({ row }) => {
      const value = row.getValue("Side") as string;
      return (
        <Badge
          className={value === "Buy" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}
          variant="outline"
        >
          {value}
        </Badge>
      );
    },
  },
  {
    accessorKey: "Volume",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Volume (MW)" />,
    cell: ({ row }) => <div>{row.getValue("Volume")}</div>,
  },
  {
    accessorKey: "PriceLimit",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Price Limit" />,
    cell: ({ row }) => <div>{row.getValue("PriceLimit")}</div>,
  },
  {
    accessorKey: "Algo",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Algo" />,
    cell: ({ row }) => {
      const value = row.getValue("Algo") as number | null;
      const className =
        value === 2
          ? "bg-blue-100 text-blue-800"
          : value === 1
            ? "bg-green-100 text-green-800"
            : "bg-gray-100 text-gray-800";
      return (
        <Badge className={className} variant="outline">
          {value ?? 0}
        </Badge>
      );
    },
  },
];
